import React, { FunctionComponent } from 'react';
import { NavLink } from 'react-router-dom';
import capitalize from 'lodash/capitalize';

interface Props {
  ovpType: string;
}

const IntegrationMessage: FunctionComponent<Props> = ({ ovpType }) => {
  const type = capitalize(ovpType);

  return (
    <p>
      {`Please connect your ${type} ovp acccount in `}
      <i>
        <NavLink to={`/settings/integrations/ovp-integrations/${ovpType}`}>OVP integration section.</NavLink>
      </i>
    </p>
  );
};

export default IntegrationMessage;
